import React from 'react';
import { createIcon } from './create-icon';
import './icon-kebab-menu.scss';

export const IconKebabMenu = createIcon(<div className="icon-kebab-menu"/>);
